import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import { Select } from './elements';

const selectOptions = [
    //{ value: "data_discrepancy", label: "Data Discrepancy" },
    // { value: "digital_issues", label: "Digital Issues", tooltip: "For problems with digital catalog data or revenue reporting" },
    { value: "digital_issues", label: "Data Issues", tooltip: "For problems with data or revenue reporting" },
    // { value: "physical_issues", label: "Physical Issues", tooltip: "For problems with physical catalog data or revenue reporting"  },
    // { value: "neighboring_rights_issues", label: "Neighboring Rights Issues", tooltip: "For problems with neighboring rights catalog data or revenue reporting"  },
    { value: "general_and_bugs", label: "General & Bugs", tooltip: "For general catalog/revenue questions or reporting technical bugs" },
    // { value: "development_and_other", label: "Development & Other", tooltip: "For new feature requests or issues that don’t fit elsewhere"  }
];

class TicketForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: '',
            description: '', 
            category: null
        };
        
        this.setCategory = this.setCategory.bind(this);
    }
    
    setCategory(category){
        this.setState({
            category
        })
    }

    render() {
        const required = value => (value ? undefined : 'Required');
        const { category } = this.state;
        const selectedOption = category ? selectOptions.find(option => option.value === category.value) : null;
        const tooltipPlaceholder = selectedOption ? selectedOption.tooltip : "Description of the issue";


        return (
            <Form
                onSubmit={this.props.onSubmit}
                onFileChange={this.props.onFileChange}
                initialValues={{}}
                validate={values => {
                    const errors = {};
                    if (!values.category) {
                        errors.category = 'Required';
                    }
                    if (!values.body) {
                        errors.body = 'Required';
                    }
                    return errors;
                }}
                render={({ handleSubmit, form, submitting, pristine, values, invalid, onFileChange }) => (
                    <form
                        className="m-t chat-modal-form"
                        onSubmit={event => {
                            setTimeout(() => {
                                form.reset();
                            }, 2000);
                            return handleSubmit(event);
                        }}
                    >
                        <div className="form-group">
                            <Field name="category">
                                {({ input, meta }) => (
                                    <div>
                                        <Select
                                            input={input}
                                            options={selectOptions}
                                            placeholder={"Select category"}
                                            className="custom-select"
                                            onChange={(option) => {
                                              input.onChange(option);
                                              this.setCategory(option);
                                            }}
                                        />
                                        {meta.error && meta.touched && <span className="error-field">{meta.error}</span>}
                                    </div>
                                )}
                            </Field>
                        </div>
                        <div className="form-group">
                            <Field name="body">
                                {({ input, meta }) => (
                                    <div>
                                        <textarea
                                            {...input}
                                            type="text"
                                            placeholder={tooltipPlaceholder}
                                            className="form-control form-field"
                                        />
                                        {meta.error && meta.touched && <span className="error-field">{meta.error}</span>}
                                    </div>
                                )}
                            </Field>
                        </div>
                        <div className="form-group">
                            <Field name="share" type="checkbox">
                                {({ input, meta }) => {
                                    return (
                                        <div className={`input-holder`}>
                                            <input
                                                {...input}
                                                type="checkbox"
                                                className="input-checkbox visually-hidden"
                                                id="shareLink"
                                            />
                                            <label className="font-normal checkbox-label" htmlFor="shareLink">
                                                Share Current Screen
                                            </label>
                                        </div>
                                    );
                                }}
                            </Field>
                        </div>
                        <div className="form-group">
                            <Field name="file">
                                {({ input, meta }) => (
                                    <div>
                                        <input
                                            {...input}
                                            type="file"
                                            className="input-file"
                                            id="chatWidgetFile"
                                            onChange={onFileChange}
                                        />
                                        <label htmlFor="chatWidgetFile" className="default-btn default-btn--small">
                                            Attach Document
                                        </label>
                                    </div>
                                )}
                            </Field>
                        </div>
                        <button type="submit" disabled={submitting || pristine || invalid} className="chat-submit">
                            Submit
                        </button>
                    </form>
                )}
            />
        );
    }
}

export default TicketForm;
